// Ensure global variables exist before other modules use them
window.WHITELABEL = window.WHITELABEL || false
window.PRODUCAO = window.PRODUCAO || false

export const PARAMETROS = {}

export function setParametros(payload) {
  Object.assign(PARAMETROS, payload)
  if (payload.hasOwnProperty('WHITELABEL')) {
    window.WHITELABEL = payload.WHITELABEL
  }
  if (payload.hasOwnProperty('PRODUCAO')) {
    window.PRODUCAO = payload.PRODUCAO
  }
}

export default PARAMETROS
